import { Surface } from '@heroui/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import type { AnalyticsExpenseItem } from '@/store/analytics.store'

interface AnalyticsExpenseRowProps {
  item: AnalyticsExpenseItem;
}

export function AnalyticsExpenseRow({ item }: AnalyticsExpenseRowProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Surface
      className="flex flex-row justify-between items-center p-4 w-full rounded-3xl cursor-pointer hover:opacity-80 transition-opacity"
      variant="secondary"
      onClick={() => navigate(`/reports/${item.reportId}`)}
    >
      <div className="flex-1 min-w-0 pr-4">
        <div className="font-medium text-sm truncate">{item.type || 'N/A'}</div>
        <div className="text-xs text-foreground/60 flex items-center gap-2 mt-0.5">
          <span>{item.documentNumber || 'No Doc'}</span>
          <span className="opacity-50">•</span>
          <span>{t('reports.report', 'Номер отчета')}: {item.identifier ? `#${item.identifier}` : item.reportNumber || 'N/A'}</span>
        </div>
      </div>
      <div className="font-bold text-right shrink-0">
        <div className="text-sm">{item.amountPLN.toFixed(2)} PLN</div>
        {item.currency !== 'PLN' && (
          <div className="text-xs text-foreground/50 font-normal">
            {item.amount.toFixed(2)} {item.currency}
          </div>
        )}
      </div>
    </Surface>
  )
}
